import { Goal, Task, Timestamp } from '@griply/types';
import { computeGoalSubgoalProgress } from '@griply/utils';
import { useMemo } from 'react';

import { useTimeframeDifference } from './use-timeframe-difference';

export type UseGoalSubgoalProgressOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
  subGoals: Goal[];
  allTasks: Task[];
};

export const useGoalSubgoalProgress = (
  goal: Goal,
  { startDate, endDate, subGoals, allTasks }: UseGoalSubgoalProgressOptions,
) => {
  const { entries, target } = useMemo(
    () => computeGoalSubgoalProgress({ goal, subGoals, tasks: allTasks }),
    [goal, subGoals, allTasks],
  );

  const timeframeDifference = useTimeframeDifference({
    entries,
    startDate,
    endDate,
    target,
  });

  const lastEntryValue = entries[entries.length - 1]?.value;
  const completionPercentage = lastEntryValue
    ? Math.floor((lastEntryValue / subGoals.length) * 100)
    : 0;

  return {
    entries,
    completionPercentage,
    completed: subGoals.filter(({ completedAt }) => !!completedAt).length,
    target,
    timeframeDifference,
  };
};
